import React, { FC, useRef } from 'react';
import { useLogging } from '../hooks/useLogging';
import { useEmitPrepared } from '../hooks/useEmitPrepared';
import { usePassCartItemsFromParentToSubscription } from '../hooks/usePassCartItemsFromParentToSubscription';
import { useGetScrollOffsetFromParent } from '../hooks/useGetScrollOffsetFromParent';
import { useFetch, FetchStateType, FetchApiType } from '../hooks/useFetch';
import { useSummary } from '../hooks/useSummary';
import { useRegisteredProduct } from '../hooks/useRegisteredProducts';
import { usePausedProducts } from '../hooks/usePausedProducts';
import { useRecommendProducts } from '../hooks/useRecommendProducts';
//import { useDeliveryDate } from '../hooks/useDeliveryDate';
//import { useSubscriptionLine } from '../hooks/useSubscriptionLine';
import { useLoadingAny } from '../hooks/useLoadingAny';
import { useEmitResetWindow } from '../hooks/useEmitResetWindow';

import classes from '../asset/css/main.module.css';
//import { Header } from '../components/SubscriptionDetail/Header';
//import { Menu } from '../components/SubscriptionDetail/Menu';

import { SubscriptionsApiType } from '../types/api/subscriptions-api-type';
import { PurchasedProductsApiType } from '../types/api/purchased-products-api-type';
import { RecommendProductVariantsApiType } from '../types/api/recommend-product-variants-api-type';

export const SubscriptionDetail: FC<{ token: string }> = ({ token }) => {

  useLogging('SubscriptionDetail');
  useEmitPrepared();

  const scrollOffset = useGetScrollOffsetFromParent();

  usePassCartItemsFromParentToSubscription(token);

  const [subscriptionsState, getSubscription] = 
    useFetch('getSubscriptions', token) as [FetchStateType, FetchApiType];

  const subscriptions = subscriptionsState.data as unknown as SubscriptionsApiType;
  const summary = useSummary(subscriptions);
  const registeredProducts = useRegisteredProduct(subscriptions);

  const [purchasedProductsState, getPurchasedproducts] = 
    useFetch('getPurchasedProducts', token) as [FetchStateType, FetchApiType];
  const pausedProducts = usePausedProducts(
    registeredProducts,
    purchasedProductsState.data as unknown as PurchasedProductsApiType
  );

  const [recommendProductsState, getRecommendProductVariants] = 
    useFetch('getRecommendProductVariants', token) as [FetchStateType, FetchApiType];
  const recommendProducts = useRecommendProducts(
    registeredProducts,
    recommendProductsState.data as unknown as RecommendProductVariantsApiType
  );

  //const [
  //  { deliveryDate, deliveryDateState },
  //  { changeDeliveryDate, updateDeliveryDate }
  //] = useDeliveryDate(subscriptions, summary, token);

  //const [
  //  { updateSubscriptionLineState, addSubscriptionLineState, removeSubscriptionLineState },
  //  { updateSubscriptionLine, addSubscriptionLine, removeSubscriptionLine }
  //] = useSubscriptionLine(
  //  subscriptions,
  //  getSubscription,
  //  getPurchasedProducts,
  //  getRecommendProductVariants,
  //  token
  //);

  const loadingAny = useLoadingAny([
    subscriptionsState.loading,
    purchasedProductsState.loading,
    recommendProductsState.loading,
    //deliveryDateState.loading,
    //updateSubscriptionLineState.loading,
    //addSubscriptionLineState.loading,
    //removeSubscriptionLineState.loading
  ]);

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(
    rootElementReference,
    [summary, registeredProducts, pausedProducts, recommendProducts]
  );

  return (
    <div className={classes.mypage_subsc_container} ref={rootElementReference}>
      test
      {/*<Header summary={summary} />
      <Menu />*/}
    </div>
  );
};
